import { useToast } from 'primevue/usetoast'
import { useI18n } from 'vue-i18n'

const life = 3_000

export function useToaster() {
  const toast = useToast()
  const { t, te } = useI18n()

  function translateIfExists(text) {
    if (!text) return text
    return te(text) ? t(text) : text
  }

  function success(props) {
    const isString = typeof props === 'string'

    if (isString) {
      const title = translateIfExists(props)
      toast.add({ severity: 'success', summary: title, life })
      return
    }

    const { title = 'Success', detail } = props
    const translatedTitle = translateIfExists(title)

    toast.add({ severity: 'success', summary: translatedTitle, detail, life })
  }

  function error(props) {
    const isString = typeof props === 'string'

    if (isString) {
      const title = translateIfExists(props)
      toast.add({ severity: 'error', summary: title, life })
      return
    }

    const { title = 'Error', detail } = props
    const translatedTitle = translateIfExists(title)

    toast.add({ severity: 'error', summary: translatedTitle, detail, life })
  }

  function info(props) {
    const isString = typeof props === 'string'

    if (isString) {
      const title = translateIfExists(props)
      toast.add({ severity: 'info', summary: title, life })
      return
    }

    const { title = 'Info', detail } = props
    const translatedTitle = translateIfExists(title)

    toast.add({ severity: 'info', summary: translatedTitle, detail, life })
  }

  return {
    success,
    error,
    info,
  }
}
